import classNames from "classnames";

export const PanelLayout = ({
  className,
  children,
  bottomChildren,
}: {
  className?: string;
  children: React.ReactNode;
  bottomChildren?: React.ReactNode;
}) => (
  <div className="h-full flex-col divide-y-025">
    <div
      className={classNames(
        "flex-initial divide-y-025 overflow-y-auto",
        className,
      )}
    >
      {children}
    </div>
    {bottomChildren ? <div className="pt-300">{bottomChildren}</div> : null}
  </div>
);
